import React, { FC } from 'react';
import { Field, Form } from 'react-final-form';

import { FORM_ERROR } from 'final-form';
import { t } from 'ttag';

import { validatePassword } from '../../lib/helpers';

import Button from '../ui/button/button';
import Input from '../ui/input/input';
import Title from '../ui/title/title';

import { getLocationQuery } from '../../lib/url';
import auth from '../../services/auth';
import PageTitle from '../pageTitle/pageTitle';

// styles
import css from './recoverPassForm.css';

const validate = (fields: Record<string, string>) => {
    const errors: Record<string, string> = {};

    if (!fields.password) {
        errors.password = t`Обов'язкове поле`;
    } else {
        const passwordErrorMessage = validatePassword(fields.password);
        if (passwordErrorMessage) {
            errors.password = passwordErrorMessage;
        }
    }

    return errors;
};

/**
 *
 * @deprecated
 * @see `cs/components/recoverPassForm/new/NewRecoverPassForm.tsx`
 */
const RecoverPassForm: FC<React.PropsWithChildren<unknown>> = () => {
    const handleSubmit = async (values: Record<string, string>) => {
        const { token = '' } = getLocationQuery(document.location);

        try {
            await auth.recoverPass({ password: values.password, token });
        } catch (err) {
            const passwordError = err.details?.password;
            const tokenError = err.details?.token && t`Невалідний токен`;
            return {
                [FORM_ERROR]: passwordError || tokenError || err.message,
            };
        }

        return {};
    };

    return (
        <div className={css.root}>
            <PageTitle>{t`Відновлення пароля`}</PageTitle>
            <Title>{t`Новий пароль`}</Title>
            <Form onSubmit={handleSubmit} validate={validate}>
                {(formProps) => (
                    <form onSubmit={formProps.handleSubmit}>
                        <div className={css.input}>
                            <div
                                className={css.hint}
                            >{t`Введіть новий пароль`}</div>
                            <Field name="password">
                                {({ input, meta }) => (
                                    <Input
                                        type="password"
                                        placeholder={t`Вигадайте пароль`}
                                        hint={t`Має містити щонайменше 8 символів, хоча б одну цифру і один символ (!'#$%*-/:;=?)`}
                                        value={input.value}
                                        onChange={input.onChange}
                                        error={meta.error && meta.dirty}
                                        valid={!meta.error && meta.dirty}
                                        errorMessage={meta.error}
                                        validMessage={t`Чудово!`}
                                    />
                                )}
                            </Field>
                        </div>
                        {formProps.submitError &&
                            formProps.submitFailed &&
                            !formProps.dirtySinceLastSubmit && (
                                <div className={css.error}>
                                    {formProps.submitError}
                                </div>
                            )}
                        <Button
                            type="submit"
                            theme="cta"
                            width="full"
                            isLoading={formProps.submitting}
                        >
                            {t`Зберегти`}
                        </Button>
                    </form>
                )}
            </Form>
        </div>
    );
};

export default RecoverPassForm;
